/**
 * Created by Kirill Mashchenko on 07.07.2018.
 */

/**
 * @class 2D sprite of {pm.data.TrainRobot}.
 * @implements pm.IsoRobotSprite
 */
var TrainRobotSprite = pm.IsoRobotSprite.extend(/** @lends TrainRobotSprite# */{
	ctor: function()
	{
		cc.animationCache.addAnimations("Robot/train_robot-animations.plist");

		pm.spriteUtils.registerTempSpriteFrames("Robot/train_robot.plist");
		pm.spriteUtils.registerTempSpriteFrames("Robot/train_robot-indicate.plist");
		pm.spriteUtils.registerTempSpriteFrames("Robot/train_robot-broken.plist");

		this._super(cc.spriteFrameCache.getSpriteFrame(this._getFrameName(0)));

		this._minPoint = cc.p(38, 35);
		this._maxPoint = cc.p(38, 5);
	},

	_getActiveSpritePosition: function()
	{
		return cc.p(27, 105);
	},

	_getCommandsSpritePosition: function()
	{
		return cc.p(27, 136);
	},

	_getFrameName: function(direction)
	{
		return "train_robot{0}.png".format(4 * direction);
	},

	_getTurnAnimationName: function(oldDirection, curDirection)
	{
		return "train_robot_{0}->{1}".format(oldDirection, curDirection);
	},

	_getDestroyAnimationName: function(direction)
	{
		return "train_robot_d_{0}".format(direction);
	},

	_getIndicateAnimationName: function(direction)
	{
		return "train_robot_i_{0}".format(direction);
	}
});
